<div class="mb-3">
  @if (control().hasLabel) {
    <mat-label [style.color]="control().labelColour">{{ control().label }}</mat-label>
  }
  <mat-list class="mat-list-dynamic">
    @for (item of diagnosisList(); track ($index + item.id + item.icD10Code); let i = $index) {
      <mat-list-item [style.color]="control().valueColour">
        @if (item.comment) {
          <span matListItemLine>{{ i + 1 }} - {{ describe(item) }}</span>
        }
        @if (!item.comment) {
          <span>{{ i + 1 }} - {{ describe(item) }}</span>
        }
        @if (item.comment) {
          <span matListItemLine>{{ item.comment }}</span>
        }
      </mat-list-item>
    }
  </mat-list>
</div>
